import React, { useContext } from "react";
import { Provider } from "react-redux";
import { store } from "./store";
import AppContainer from "./AppContainer";
import { BrowserRouter } from "react-router-dom";
import MenuEchoPulse from "./views/MenuEchoPulse/MenuEchoPulse";

const App: React.FC = () => {
  return (
    <>
      <Provider store={store}>
          <BrowserRouter>
          {/* <MenuEchoPulse/> */}
            <AppContainer/>
          </BrowserRouter>
      </Provider>
    </>
  );
};

export default App;

